import { combineReducers } from 'redux';

// import shiftSelectors from './selectors';
import loadingStateReducerFactory from '@nhl/loading-state-reducer-factory';

import actionTypes from './actionTypes';

const loadingStateReducer = loadingStateReducerFactory(actionTypes.REQUEST_PPT_DATA)(actionTypes.PPT_DATA_RESPONSE);

const pptReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.PPT_DATA_RESPONSE:
            return action.payload.response;
        default:
            return state;
    }
};

const teamDataReducer = (state = [], action) => {
    switch (action.type) {
        case actionTypes.TEAM_DATA_RESPONSE:
            return action.payload.response;
        default:
            return state;
    }
};

const gameReducer = (state = {}, action) => {
    switch (action.type) {
        case actionTypes.GAME_DATA_RESPONSE:
            return action.payload.response;
        default:
            return state;
    }
};

const reducer = combineReducers({
    loadingState: loadingStateReducer,
    game: gameReducer,
    teamData: teamDataReducer,
    pptData: pptReducer,
});

export default reducer;
